import Hero from "../Hero";
import Navbar from "../Navbar"
import OurClub from "../ourClub";
import Events from "../Events";
import Footer from "../Footer";

function Home(){
    return(
        <>
        <Navbar />
        <Hero
        cName="/hero"
        heroImg="/assert/ito.png"
        /> <br/><hr/>
        <OurClub />
        <hr/>
        <Events />
        
        <Footer />
        </>
    );
}

export default Home;